export const GwrSearchModeName = 'searchMode';
